import TRASH_BOMB_SPLAT_IMAGE_URL from './trashSplat.png';
export { TRASH_BOMB_SPLAT_IMAGE_URL };
export const TRASH_BOMB_SPLAT_SPRITESHEET_DATA = {
    frames: {
        'trashSplat0001.png': {
            frame: { x: 1, y: 1, w: 166, h: 193 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 14, y: 0, w: 166, h: 193 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0002.png': {
            frame: { x: 1, y: 536, w: 194, h: 198 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 28, w: 194, h: 198 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0003.png': {
            frame: { x: 1, y: 733, w: 187, h: 243 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 1, y: 16, w: 187, h: 243 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0004.png': {
            frame: { x: 196, y: 1, w: 166, h: 288 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 9, y: 4, w: 166, h: 288 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0005.png': {
            frame: { x: 486, y: 1, w: 174, h: 321 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 6, y: 4, w: 174, h: 321 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0006.png': {
            frame: { x: 1, y: 169, w: 181, h: 355 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 5, y: 4, w: 181, h: 355 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0007.png': {
            frame: { x: 201, y: 545, w: 186, h: 388 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 186, h: 388 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0008.png': {
            frame: { x: 623, y: 741, w: 189, h: 346 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 189, h: 346 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0009.png': {
            frame: { x: 246, y: 741, w: 188, h: 375 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 188, h: 375 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0010.png': {
            frame: { x: 591, y: 553, w: 186, h: 387 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 186, h: 387 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0011.png': {
            frame: { x: 358, y: 177, w: 182, h: 368 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 182, h: 368 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0012.png': {
            frame: { x: 204, y: 361, w: 182, h: 400 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 182, h: 400 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0013.png': {
            frame: { x: 809, y: 1, w: 182, h: 200 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 182, h: 200 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0014.png': {
            frame: { x: 728, y: 185, w: 182, h: 200 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 182, h: 200 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0015.png': {
            frame: { x: 1, y: 352, w: 182, h: 201 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 182, h: 201 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0016.png': {
            frame: { x: 606, y: 369, w: 182, h: 201 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 182, h: 201 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        },
        'trashSplat0017.png': {
            frame: { x: 809, y: 369, w: 182, h: 202 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 4, w: 182, h: 202 },
            sourceSize: { w: 194, h: 404 },
            anchor: { x: 0.505155, y: 0.425743 }
        }
    },
    animations: {
        trashSplat: [
            'trashSplat0001.png',
            'trashSplat0002.png',
            'trashSplat0003.png',
            'trashSplat0004.png',
            'trashSplat0005.png',
            'trashSplat0006.png',
            'trashSplat0007.png',
            'trashSplat0008.png',
            'trashSplat0009.png',
            'trashSplat0010.png',
            'trashSplat0011.png',
            'trashSplat0012.png',
            'trashSplat0013.png',
            'trashSplat0014.png',
            'trashSplat0015.png',
            'trashSplat0016.png',
            'trashSplat0017.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.1',
        image: TRASH_BOMB_SPLAT_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 1012, h: 931 },
        scale: '0.3',
        smartupdate: '$TexturePacker:SmartUpdate:dbcea7bda26174543f91156410e24810:59d3b1a8eba669ca2c14771621ffa066:bc3e559bce2bcdb5cf078b798a7e1336$'
    }
};
